import styled from 'styled-components';
import { zIndex } from '../../../../utils';

export const Wrapper = styled.div`
  position: fixed;
  z-index: ${zIndex.level4};
  overflow: auto;
  top: 0px;
  right: -275px;
  width: 0;
  opacity: 0;
  height: 100%;
  background-color: #151515;
  transition: all 350ms cubic-bezier(0.6, 0.05, 0.28, 0.91);

  ${({ active }) =>
    active &&
    `
			right: 0px;
      opacity: 1;
      width: 100%;
	`}
`;
